import { faMicrophone, faMicrophoneSlash, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import APIResultMessage from 'components/common/APIResultMessage';
import DynamicInput from 'components/common/DynamicInput';
import { LOCALE } from 'constants';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import { useFetchData } from 'hooks/apiHooks';
import useSpeechToText from 'hooks/useSpeechToText';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';

const FeedbackForm = ({feedbackContext}) => {
    const { transcript, isListening, error: listenError, startListening, stopListening, setTranscript } = useSpeechToText(LOCALE);
    const [submitAfterSpeakingTimeout, setSubmitAfterSpeakingTimeout] = useState(null);
    const { triggerUpdate: sendFeedback, setUpdateSuccess, updateSuccess, updateError  } = 
        useFetchData(null, `/api/data/feedback`, false);
    const { userSettings } = useContext(UserSettingsContext);
    const [listenStarted, setListenStarted] = useState(false);
    
    const handleMicrophoneClick = () => {
            if (isListening) {
                    stopListening();
            } else {
                    setListenStarted(true)
                    startListening();
            }
    };

    const handleSubmit = async () => {
            clearTimeout(submitAfterSpeakingTimeout);
            stopListening()
            sendFeedback(null, {value: transcript, context: feedbackContext})
    }

    const handleInputChange = (e) => {
        setUpdateSuccess(null)
        setTranscript(e.target.value)
    }

    useEffect(() => {
            clearTimeout(submitAfterSpeakingTimeout);
            if(listenStarted && transcript && userSettings.auto_send_after_talking){
                    setSubmitAfterSpeakingTimeout(setTimeout(handleSubmit, 2000));
            }
        }, [transcript]);

    return (
        <>
            <Row className="mb-1">
            <APIResultMessage success={updateSuccess && {message:"Thank you for the feedback"}} error={updateError}/>
                <Col md="12" className="d-flex">
                    <DynamicInput
                            onChange={handleInputChange}
                            value={transcript}
                            label={"Please provide Feedback"}/>
                    <IconButtonWithTooltip translationId={`feedback.submit`} icon={faPaperPlane} onClick={handleSubmit} type="ButtonPrimary" />
                    <IconButtonWithTooltip translationId={`emails.ai.speak`} icon={isListening ? faMicrophoneSlash : faMicrophone} onClick={handleMicrophoneClick} type="Button"/>
                </Col>
            </Row>
        </>
    );
};

export default FeedbackForm;